import type { VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/styles/utils.ts';
import { textVariants } from '@/shared/ui/Typography/variants.ts';
import type { TextTag } from '@/shared/ui/Typography/types.ts';
import type { ComponentPropsWithoutRef } from 'react';

type Props<T extends TextTag> = {
  as?: T;
  ellipsis?: boolean;
  leading?: number | string;
} & ComponentPropsWithoutRef<T> &
  VariantProps<typeof textVariants>;

export const Typography = <T extends TextTag = 'span'>({
  as,
  ellipsis = false,
  leading,
  children,
  className,
  type,
  weight,
  color,
  align,
  ...props
}: Props<T>) => {
  const Tag = as || 'span';
  return (
    <Tag
      {...props}
      className={cn(
        textVariants({ type, weight, color, align }),
        leading && `leading-${leading}`,
        className,
        ellipsis && 'overflow-hidden text-ellipsis whitespace-nowrap'
      )}
    >
      {children}
    </Tag>
  );
};
